/** @jsxRuntime classic  */
/** @jsx jsx */
import { PureComponent, ReactNode } from 'react';

import { jsx } from '@emotion/core';

import * as styles from '../styles';

export type CodeProps = {
  // needed in order to support the consumer overriding with styled-components
  className?: string;
  generateLineKey: (source: ReactNode, idx: number) => string;
  renderGutterLine?: (idx: number) => ReactNode;
  renderSourceLine: (source: ReactNode, idx: number) => ReactNode;
  sourceLines: ReactNode[];
};

export default class Code extends PureComponent<CodeProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    generateLineKey: (_source: ReactNode, idx: number) => `${idx}`,
    renderSourceLine: (source: ReactNode) => (
      /* eslint react/no-unknown-property: "warn" */
      <td css={styles.SourceCodeLine}>
        <span css={styles.SourceCodeText}>{source}</span>
      </td>
    ),
  };

  render() {
    return (
      <tbody css={styles.SourceCodeBlock} className={this.props.className}>
        {this.props.sourceLines.map((source, idx) => (
          <tr key={this.props.generateLineKey(source, idx)}>
            {!!this.props.renderGutterLine && this.props.renderGutterLine(idx)}
            {this.props.renderSourceLine(source, idx)}
          </tr>
        ))}
      </tbody>
    );
  }
}
